import React from "react";
import GridContainer from "../../../@jumbo/components/GridContainer";
import PageContainer from "../../../@jumbo/components/PageComponents/layouts/PageContainer";
import IntlMessages from "../../../@jumbo/utils/IntlMessages";

import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";

import BlogElement from "@jumbo/Dashboards/News/BlogElement";

const breadcrumbs = [
  { label: <IntlMessages id={"sidebar.main"} />, link: "/" },
  { label: <IntlMessages id={"pages.newsPage"} />, link: "/news" },
  { label: <IntlMessages id={"pages.createBlog"} />, isActive: true },
];

const CreateBlog = () => {
  return (
    <PageContainer
      heading={<IntlMessages id="pages.createBlog" />}
      breadcrumbs={breadcrumbs}
    >
      <GridContainer>
        <Grid item xs={12}>
          <Divider />
          <div style={{ marginTop: 24 }}>
            <BlogElement />
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default CreateBlog;
